<template>
	<div id="app">
		<div id="main">
			<div class="loader" :class="{ hidden: !loading }">
				<div class="loaderimg">
				</div>
			</div>
			<div id="page" v-if="!loading">
				<div id="header" class="grid full" :class="{ quiz: user.location === 'quiz' }">
					<div class="title">{{ data.title }}</div>
					<div class="subtitle">{{ data.subtitle }}</div>
					<div class="authors">
						<div v-for="author in data.authors" :key="author">{{ author }}<br></div>
					</div>
					<img class="logo" src="./assets/curtin-logo.png"/>
					<img class="back" src="banner.jpg"/>
				</div>
				<div class="grid full body">
					<div class="grid full" v-if="user.location === 'start'">
						<div class="box">
							<h3 style="text-align: center;">Welcome!</h3>
							<div v-html="data.welcome"></div>
							<div class="btn" @click="user.location = 'quiz'">Start Quiz</div>
						</div>
					</div>
					<div class="grid full" v-else-if="user.location === 'quiz'">
						<h3>{{ 'Question ' + (user.question + 1) + ': ' + data.quiz[user.question].title }}</h3>
						<div id="progress">
							<div :style="{ width: user.question/data.quiz.length * 100 + '%' }">{{ user.question ? parseFloat((user.question/data.quiz.length * 100).toFixed(1)) + '%' : '' }}</div>
						</div>
						<h6>Instructions: Please watch the following video</h6>
						<div class="seperator"></div>
						<div class="video" v-html="data.quiz[user.question].firstVideo"></div>
						<div class="seperator"></div>
						<h6>Mark the following statement as <span v-for="(option, i) in data.options" :key="option">{{ (i === data.options.length - 1 ? ' or ' : (i ? ', ' : '')) + '\'' + option + '\'' }}</span>:</h6>
						<div class="box">
							<p>{{ data.quiz[user.question].statement }}</p>
						</div>
						<div class="full grid" v-if="!user.review">
							<div class="full grid" style="height: 1.5em;">
								<div class="mc-outer">
									<div class="mc-inner">
										<div v-for="(option, i) in data.options" :key="option">
											<input :id="'option' + i" type="radio" v-model="user.responses[user.attempt][user.question]" :value="i">
											<label :for="'option' + i">{{ option }}</label>
										</div>
									</div>
								</div>
							</div>
							<div class="full grid">
								<div class="btn" :class="{ inactive: user.responses[user.attempt][user.question] === '' }" @click="submitQuestion()">Submit</div>
							</div>
						</div>
						<div class="grid full" v-else>
							<div class="box" :class="[user.responses[user.attempt][user.question] === data.quiz[user.question].option ? 'success' : 'failure']">
								<h3>{{ user.responses[user.attempt][user.question] === data.quiz[user.question].option ? 'Well Done!' : 'Incorrect' }}</h3>
								<p>{{ 'You answered ' + (user.responses[user.attempt][user.question] === data.quiz[user.question].option ? 'correctly' : 'incorrectly') + ', the statement was '  + (user.responses[user.attempt][user.question] === data.quiz[user.question].option ? '' : 'actually ') + data.options[data.quiz[user.question].option].toLowerCase() + '.' }}</p>
							</div>
							<div class="card">
								<p v-html="data.quiz[user.question].explanation"></p>
								<p v-if="data.quiz[user.question].references.length"><em>References:</em></p>
								<p v-for="ref in data.quiz[user.question].references" :key="ref"><em>{{ ref }}</em></p>
							</div>
							<div class="box" :class="[data.quiz[user.question].option ? 'success' : 'failure']">
								<h4>The first video contained {{ (data.quiz[user.question].option ? data.options[1] : data.options[0] ).toLowerCase() }} advice. The following video shows {{ (data.quiz[user.question].option ? data.options[0] : data.options[1] ).toLowerCase() }} advice to give.</h4>
								<div class="seperator"></div>
								<div class="video" v-html="data.quiz[user.question].secondVideo"></div>
							</div>
							<div class="btn" @click="user.question++; user.review = false" v-if="user.question !== data.quiz.length - 1">Next Question</div>
							<div class="btn" @click="submitLastQuestion()" v-else>Next</div>
						</div>
					</div>
					<div class="grid full" v-else-if="user.location === 'end'">
						<div class="box">
							<h3 style="text-align: center;">Finish</h3>
							<div style="text-align: center; margin-bottom: 3em;">Thank you for completing the quiz.</div>
							<div class="btn" @click="user.location = 'start'; updateDataInteraction(); updateSuspendData();">Home</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pipwerks from 'pipwerks-scorm-api-wrapper'

export default {
	name: 'app',
	data () {
		return {
			scorm: false,
			loading: true,
			data: '',
			user: {
				studentName: '',
				studentNumber: '',
				location: 'start',
				attempt: 0,
				question: 0,
				review: false,
				responses: [],
				date: new Date(),
				score: 0
			}
		}
	},
	mounted () {
		this.axios.get('data.json').then((response) => {
			new Promise((resolve, reject) => {
				this.data = response.data
				this.user.responses.push(this.data.quiz.map(() => { return '' }))

				pipwerks.SCORM.handleCompletionStatus = false
				pipwerks.SCORM.handleExitMode = false
				if (this.initiateSuspendData()) {
					// console.log('New Attempt')
					resolve()
				}
			}).then(() => {
				this.loading = false
			}).catch((err) => {
				console.log('Data Process Error')
				console.log(err)
			})
		}).catch((err) => {
			console.log('Data Load Error')
			console.log(err)
		})
	},
	methods: {
		formatTime: function (date) {
			if (date !== '') {
				let h = date.getHours()
				let m = date.getMinutes()
				let s = date.getSeconds()
				return ('00' + h).slice(-2) + ':' + ('00' + m).slice(-2) + ':' + ('00' + s).slice(-2)
			} else {
				console.log('No date')
			}
		},
		formatDate: function (date) {
			if (date !== '') {
				let d = date.getDate()
				let mo = date.getMonth()
				let y = date.getFullYear()
				return d + '/' + (mo + 1) + '/' + y
			} else {
				console.log('No date')
			}
		},
		initiateSuspendData: function () {
			// Initiate Suspend Data
			// console.log('Initiate Suspend Data')
			if (pipwerks.SCORM.init()) {
				this.scorm = true
				let scormComp = pipwerks.SCORM.get('cmi.completion_status')
				if (scormComp === 'unknown') {
					pipwerks.SCORM.set('cmi.completion_status', 'incomplete')
					// Get Learner name form Bb and re format
					let learnerName = pipwerks.SCORM.get('cmi.learner_name')
					let firstName = learnerName.substr(learnerName.indexOf(',') + 2)
					let lastName = learnerName.substr(0, learnerName.indexOf(','))
					this.user.studentName = firstName + ' ' + lastName

					this.user.studentNumber = pipwerks.SCORM.get('cmi.learner_id')
					pipwerks.SCORM.set('cmi.exit', 'suspend')
					pipwerks.SCORM.save()

					this.updateSuspendData()

					return true
				} else {
					let previousData = pipwerks.SCORM.get('cmi.suspend_data')
					console.log(previousData)
					let userData = JSON.parse(previousData, true)
					this.user = userData

					return true
				}
			} else {
				// No SCORM Found
				return true
			}
		},
		updateSuspendData: function () {
			// Update SCORM Suspend Data
			if (this.scorm) {
				let suspendData = JSON.stringify(this.user)
				console.log(suspendData)
				pipwerks.SCORM.set('cmi.suspend_data', suspendData)
				return pipwerks.SCORM.save()
			}
		},
		createInteraction: function (description, response, correct) {
			// Create SCORM Interactions
			// console.log('Create SCORM Interaction')
			if (this.scorm) {
				let ncount = pipwerks.SCORM.get('cmi.interactions._count')
				pipwerks.SCORM.set('cmi.interactions.' + ncount + '.id', 'int-' + ncount)
				pipwerks.SCORM.set('cmi.interactions.' + ncount + '.type', 'other')
				pipwerks.SCORM.set('cmi.interactions.' + ncount + '.learner_response', response)
				pipwerks.SCORM.set('cmi.interactions.' + ncount + '.result', correct)
				pipwerks.SCORM.set('cmi.interactions.' + ncount + '.description', description + '|')
			}
		},
		updateDataInteraction: function () {
			// Update Data SCORM Interaction
			if (this.scorm) {
				let headerText = 'QuizName,User,UserId,Attempt,Id,Response,Outcome'
				let tempText = ''
				let frontText = this.data.title + ' ' + this.data.subtitle + ',' + this.user.studentName + ',' + this.user.studentNumber + ','

				for (let i = 0; i < this.user.responses.length; i++) {
					for (let j = 0; j < this.user.responses[i].length; j++) {
						if (this.user.responses[i][j] !== '') {
							tempText += frontText
							tempText += i + 1 + ','
							tempText += j + 1 + ','
							tempText += this.data.options[this.user.responses[i][j]] + ','
							tempText += this.user.responses[i][j] === this.data.quiz[j].option ? 'correct' : 'incorrect' + '\n'
						}
						if (i === this.user.responses.length - 1 && j === this.user.responses[i].length - 1) {
							let newDate = new Date()
							pipwerks.SCORM.set('cmi.interactions.0.id', 'int-0')
							pipwerks.SCORM.set('cmi.interactions.0.type', 'other')
							pipwerks.SCORM.set('cmi.interactions.0.learner_response', '>> <a style="font-weight: bold;" href="data:text/csv;charset=utf-8,' + encodeURIComponent(headerText + '\n' + tempText) + '" download="attempt.csv" target="_blank">Download Record</a> <<')
							pipwerks.SCORM.set('cmi.interactions.0.result', 'neutral')
							pipwerks.SCORM.set('cmi.interactions.0.description', 'Data Updated At: ' + this.formatDate(newDate) + ',' + this.formatTime(newDate))
							pipwerks.SCORM.save()
						}
					}
				}
			}
		},
		terminateActivity: function () {
			// Terminate Activity
			if (this.scorm) {
				if (this.updateSuspendData()) {
					pipwerks.SCORM.set('cmi.exit', 'suspend')
					pipwerks.SCORM.set('adl.nav.request', 'exit')
					pipwerks.SCORM.save()
					pipwerks.SCORM.quit()
				}
			}
		},
		submitQuestion: function () {
			this.user.review = true
			this.updateSuspendData()
			this.updateDataInteraction()
			this.createInteraction('A' + (this.user.attempt + 1) + 'Q' + (this.user.question + 1) + ': ' + this.data.quiz[this.user.question].title, this.data.options[this.user.responses[this.user.attempt][this.user.question]], this.user.responses[this.user.attempt][this.user.question] === this.data.quiz[this.user.question].option ? 'correct' : 'incorrect')
		},
		submitLastQuestion: function () {
			this.user.location = 'end'
			this.user.review = false
			this.user.question = 0
			this.updateDataInteraction()
			this.user.attempt++
			this.user.responses.push(this.data.quiz.map(() => { return '' }))
			this.updateSuspendData()
		}
	}
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');

body {
	margin: 0;
	background-color: rgb(243, 242, 242);
}

#app {
	font-family: 'Segoe UI', 'Roboto', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #212529;
}

#main {
	width: 100%;
}

#page {
	position: relative;
	width: 800px;
	min-height: 100vh;
	margin-left: auto;
	margin-right: auto;
	box-sizing: border-box;
	background-color: #fff;
	border-left: 1px solid #b8b8b8;
	border-right: 1px solid #b8b8b8;
	padding-bottom: 1em;
}

/* Text */

h1, h2, h3, h4, h5, h6, p {
	margin-top: 0;
	margin-bottom: 1rem;
    line-height: 1.2;
}

p {
    line-height: 1.5;
}

p:last-child {
	margin-bottom: 0;
}

h3 {
	font-size: 1.4em;
	font-weight: 500;
}

h6 {
	color: #6c757d;
	font-size: 1em;
	font-weight: 500;
}

/* Header */

#header {
	/*min-height: 290px;*/
	padding: 1.2rem;
	/* background-image: url('banner.jpg');
	background-size: 100% auto;
	background-repeat: no-repeat; */
	overflow: hidden;
}

#header>.back {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
}

#header.quiz>.back {
	display: none;
}

#header div {
	position: relative;
	z-index: 5;
}

#header:before {
	display: block;
	content: '';
	position: absolute;
	top: -88%;
	left: -88%;
	background-color: rgba(255,255,255,0.7);
	width: 200%;
	height: 200%;
	z-index: 1;
	transform: rotate(-70deg);
	-moz-transform: rotate(-70deg);
	-webkit-transform: rotate(-70deg);
}

#header .logo {
	position: absolute;
	top: 1.2em;
	right: 0;
	height: 40px;
	width: auto;
	z-index: 10;
}

#header .title {
	max-width: 400px;
	font-size: 2.1em;
    font-weight: 500;
    line-height: 1.2;
	margin-bottom: 0.5rem;
}

#header .subtitle {
	max-width: 300px;
	font-size: 1.4em;
    font-weight: 400;
    line-height: 1.2;
	margin-bottom: 2rem;
}

#header .authors {
	font-size: 1em;
    font-weight: 500;
    line-height: 1.2;
	margin-top: 1rem;
	margin-bottom: 1rem;
}

#header .authors>div {
	width: 100%;
	margin-bottom: 0.2em;
}

/* Body */

.body {
	padding: 1.2rem;
}

.seperator {
	position: relative;
	float: left;
	height: 0;
	width: 100%;
	margin-bottom: 1em;
	border-bottom: 1px solid rgba(0,0,0,.1)
}

.box {
	padding: 1.2rem;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
	margin-bottom: 1em;
}

.card {
	padding: 1.2rem;
	margin-bottom: 1em;
	box-shadow: 1px 1px 5px 1px rgba(145,145,145,1);
	-moz-box-shadow: 1px 1px 5px 1px rgba(145,145,145,1);
	-webkit-box-shadow: 1px 1px 5px 1px rgba(145,145,145,1);
}

.mc-outer {
	position: absolute;
	left: 50%;
}

.mc-inner {
	position: relative;
	left: -50%;
}

.mc-inner>div {
	float: left;
	cursor: pointer;
	margin: 0em 0.5em 0.5em 0.5em;
}

.mc-inner>div>label {
	padding-left: 0.2em;
}

.video {
	position: relative;
    width: 100%;
    height: 0;
    /* padding-bottom: 56.25%; */
    padding-bottom: 70%;
}

.video>iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.btn {
	cursor: pointer;
	margin-left: auto;
	margin-right: auto;
	max-width: 300px;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    padding: .375rem .75rem;
	margin-top: 1em;
    font-size: 1rem;
    line-height: 1.5;
    color: #fff;
    background-color: #007bff;
    border-radius: .25rem;
	transition: color .15s ease-in-out, background-color .15s ease-in-out, box-shadow .15s ease-in-out;
	-o-transition: color .15s ease-in-out, background-color .15s ease-in-out, box-shadow .15s ease-in-out;
	-ms-transition: color .15s ease-in-out, background-color .15s ease-in-out, box-shadow .15s ease-in-out;
	-moz-transition: color .15s ease-in-out, background-color .15s ease-in-out, box-shadow .15s ease-in-out;
	-webkit-transition: color .15s ease-in-out, background-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.btn:hover {
    background-color: #0069d9;
}

.success {
	color: #155724;
	background-color: #d4edda;
	border-color: #c3e6cb;
}

.failure {
	color: #721c24;
	background-color: #f8d7da;
	border-color: #f5c6cb;
}

/* Progress */

#progress {
	position: relative;
	width: 100%;
	height: 1.1em;
    border-radius: .25rem;
	overflow: hidden;
	background-color: #e9ecef;
	margin-bottom: 0.5em;
}

#progress>div {
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	font-size: 0.8em;
	background-color: #007bff;
	color: #fff;
	text-align: center;
	transition: width .6s ease;
	-o-transition: width .6s ease;
	-ms-transition: width .6s ease;
	-moz-transition: width .6s ease;
	-webkit-transition: width .6s ease;
}

/* Grid */

.grid {
	position: relative;
	box-sizing: border-box;
}

.full.grid {
	clear: both;
	width: 100%;
}

.half.grid {
	width: 50%;
}

.thrd.grid {
	width: 33.3%;
}

.qtr.grid {
	width: 25%;
}

.thrqtr.grid {
	width: 75%;
}

.center {
	margin-right: auto;
	margin-left: auto;
}

/* Loader */

.loader {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding-top: 45vh;
	background-color: #fff;
	opacity: 1;
	z-index: 99;
	pointer-events: none;
	transition: opacity 0.3s linear;
	-moz-transition: opacity 0.3s linear;
	-webkit-transition: opacity 0.3s linear;
}

.loader.hidden {
	opacity: 0;
}

.loaderimg {
	margin-left: auto;
	margin-right: auto;
	border: 0.5em solid #ddd;
	border-top: 0.5em solid #bbb;
	border-radius: 50%;
	width: 5em;
	height: 5em;
	animation: loaderspin 1s linear infinite;
}

@keyframes loaderspin {
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
}

/* General */

.small {
	font-size: 0.9em;
	color: #717171;
}

.right {
	float: right;
}

.inactive {
	opacity: 0.4 !important;
	pointer-events: none !important;
}

/* Media Queries */

@media (max-width: 800px) {

	#page {
		width: 100%;
		border-width: 0;
	}

}
</style>
